import { AnimatePresence } from "framer-motion";
import React from "react";

export interface PresenceProps {
  /** Content to animate on mount/unmount */
  children: React.ReactNode;
  /** Animation mode */
  mode?: "wait" | "sync" | "popLayout";
  /** Unique key for tracking children (required for proper animation) */
  presenceKey?: string | number;
}

/**
 * Presence primitive component
 * Wrapper around Framer Motion's AnimatePresence for mount/unmount animations
 */
export function Presence({ children, mode = "sync", presenceKey }: PresenceProps) {
  // When presenceKey is provided, apply it directly to the child element
  // to allow AnimatePresence to properly track component changes for animations.
  // If children is not a valid React element, fall back to wrapping it.
  const content =
    presenceKey !== undefined && React.isValidElement(children) ? (
      React.cloneElement(children, { key: presenceKey })
    ) : presenceKey !== undefined ? (
      <div key={presenceKey}>{children}</div>
    ) : (
      children
    );

  return <AnimatePresence mode={mode}>{content}</AnimatePresence>;
}
